<template>
    <div class="node-properties-inner">
        <select v-model="properties.geofence">
            <option v-for="geofence in geofences" :value="geofence.id">{{ geofence.name }}</option>
        </select>
    </div>
</template>

<script>
import geofences from "@/geofences.js";

export default {
    computed: {
        geofences() { return geofences.fragmentGeofences; }
    },
    props: {
        properties: { type: Object, required: true }
    }
}
</script>